export const QUESTION_QUERY_MIN_LENGTH = 2;
